export default {
  name: 'marking--reportH',
  apiService: 'shoes',
  apiPath: '/admin/report_h',
};